<template>
  <nav>
    <div
      class="floral"
      :class="`collections-${$store.state.theme}-common-floral`"
    />
    <div class="list">
      <ul>
        <PushButton
          v-if="!$isMobile"
          :label="$config.history.cta"
          :to="`/history/${collection.id}`"
          :background="`collections-${$store.state.theme}-common-photo-genie-push`"
        />
        <PushButton
          v-if="!$isMobile"
          :label="$config.common.faq.cta"
          :background="`collections-${$store.state.theme}-pattern-push`"
          @click.native="scrollToFaq"
        />
        <h4>{{ $content.h4 }}<b>{{ collection.genie }}</b></h4>
        <ProductListCard
          v-for="product in products"
          :key="product.id"
          :product="product"
        />
      </ul>
      <PushButton
        v-if="$isMobile"
        :label="$config.history.cta"
        :to="`/history/${collection.id}`"
        :background="`collections-${$store.state.theme}-common-photo-genie-push`"
      />
      <div
        id="faq"
        class="faq"
      >
        <div v-if="$isMobile">
          {{ $config.common.faq.cta }}
        </div>
        <FaqList />
      </div>
    </div>
  </nav>
</template>
<script>
import PushButton from '@/components/common/PushButton.vue';
import FaqList from '@/components/common/faq/FaqList.vue';
import ProductListCard from '@/components/common/ProductListCard.vue';

export default {
  components: {
    ProductListCard,
    PushButton,
    FaqList,
  },

  props: {
    collection: {
      type: Object,
      required: true,
    },
  },

  computed: {
    products() {
      const p = this.collection.products;
      if (!Array.isArray(p) || !p.length) return [];
      // Get all waves present
      const waves = [...new Set(p.map(prod => prod.wave))].sort((a, b) => a - b);
      // Get current wave (from store or prop)
      const currentWave = this.$currentWave;
      // Group products by wave
      const grouped = {};
      p.forEach((prod) => {
        if (!grouped[prod.wave]) grouped[prod.wave] = [];
        grouped[prod.wave].push(prod);
      });
      // Sort each wave group by value descending
      Object.keys(grouped).forEach((wave) => {
        grouped[wave].sort((a, b) => b.value - a.value);
      });

      // 1. current wave first
      // 2. previous waves (lower than current) in decreasing order
      // 3. remaining waves (higher than current) in ascending order
      let ordered = [];
      if (grouped[currentWave]) {
        ordered = ordered.concat(grouped[currentWave]);
      }
      const previousWaves = waves.filter(wave => wave < currentWave).sort((a, b) => b - a);
      previousWaves.forEach((wave) => {
        if (grouped[wave]) {
          ordered = ordered.concat(grouped[wave]);
        }
      });
      const remainingWaves = waves.filter(wave => wave > currentWave).sort((a, b) => a - b);
      remainingWaves.forEach((wave) => {
        if (grouped[wave]) {
          ordered = ordered.concat(grouped[wave]);
        }
      });
      return ordered;
    },
  },
  methods: {
    scrollToFaq() {
      const faqElement = document.getElementById('faq');
      if (faqElement) {
        faqElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
nav {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  div.floral {
    height: auto;
    background-repeat: repeat-y;

    +mobile() {
      display: none;
    }
  }

  div.list {
    width: 100%;
    background: var(--white-color);
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    +desktop() {
      width: 300px;
    }
    ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      width: 100%;

      +desktop(){
        align-items: flex-end;
      }
      h4 {
        font-size: 18px;
        font-weight: normal;
        text-align: center;
        color: var(--inverted-text-color);
        width: 100%;
        padding: 15px 0 5px;
        line-height: 1.1;

        b {
          display: block;
        }
      }
    }

    div.faq {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      div {
        color: var(--inverted-text-color);
        text-align: left;
        font-size: 18px;
      }
    }
  }
}
</style>
